<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="added-text">
            <div class="page-title">
              <h2>
                Setting & Data <span>|</span> General <span>|</span> Added Texts
              </h2>
            </div>
            <div class="added-text__items">
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                    >Welcome to Tanzania</span
                  >
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.welcome"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.welcome"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.welcome].welcome"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                    >Welcome to Tanzania (VIP)</span
                  >
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.welcomeVip"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.welcomeVip"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.welcomeVip].welcomeVip"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Getting Visa</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.visa"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.visa"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    @focus="isEditFlag = true"
                    v-model="data[lang.visa].visa"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Getting Visa (VIP)</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.visaVip"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.visaVip"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    @focus="isEditFlag = true"
                    v-model="data[lang.visaVip].visaVip"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                    >Wish you a safety travel back</span
                  >
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.back"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.back"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.back].back"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Summit Kilimanjaro</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.summitKilimanjaro"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.summitKilimanjaro"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.summitKilimanjaro].summitKilimanjaro"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Summit Meru</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.summitMeru"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.summitMeru"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.summitMeru].summitMeru"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Own Arrangements</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.ownArrangements"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.ownArrangements"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.ownArrangements].ownArrangements"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Rest Day</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.restDay"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.restDay"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.restDay].restDay"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Transit Ngorongoro</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.transitNgorongoro"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.transitNgorongoro"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.transitNgorongoro].transitNgorongoro"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                  >Arrival</span
                  >
                  <div class="languages-group">
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.arrival"
                          value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >English</span
                      >
                    </label>
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.arrival"
                          value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                      :editor="editor"
                      v-model="
                      data[lang.arrival]
                        .arrival
                    "
                      @focus="isEditFlag = true"
                      :config="editorConfig">
                  </editor>
                </div>
              </div>

              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                  >Arrival VIP</span
                  >
                  <div class="languages-group">
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.arrivalVip"
                          value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >English</span
                      >
                    </label>
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.arrivalVip"
                          value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                      :editor="editor"
                      v-model="
                      data[lang.arrivalVip]
                        .arrivalVip
                    "
                      @focus="isEditFlag = true"
                      :config="editorConfig">
                  </editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Departure</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.departure"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.departure"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.departure].departure"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title">Departure VIP</span>
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.departureVip"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.departureVip"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.departureVip].departureVip"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>

              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                    >COVID-19 REGULATIONS</span
                  >
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.covidRegulations"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.covidRegulations"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="data[lang.covidRegulations].covidRegulations"
                    @focus="isEditFlag = true"
                    :config="editorConfig"></editor>
                </div>
              </div>

              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                    >Departure from national park</span
                  >
                  <div class="languages-group">
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.departureFromNationalPark"
                        value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >English</span
                      >
                    </label>
                    <label
                      class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                        type="radio"
                        name="lanuage"
                        v-model="lang.departureFromNationalPark"
                        value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                        >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                    :editor="editor"
                    v-model="
                      data[lang.departureFromNationalPark]
                        .departureFromNationalPark
                    "
                    @focus="isEditFlag = true"
                    :config="editorConfig">
                  </editor>
                </div>
              </div>

              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                  >Prohibited for import into Tanzania</span
                  >
                  <div class="languages-group">
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.arrivalImport"
                          value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >English</span
                      >
                    </label>
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.arrivalImport"
                          value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                      :editor="editor"
                      v-model="
                      data[lang.arrivalImport]
                        .arrivalImport
                    "
                      @focus="isEditFlag = true"
                      :config="editorConfig">
                  </editor>
                </div>
              </div>
              <div class="added-text__item">
                <div class="added-text__item-head">
                  <span class="added-text__item-title"
                  >Prohibited for export from Tanzania</span
                  >
                  <div class="languages-group">
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.departureExport"
                          value="EN" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-gb">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >English</span
                      >
                    </label>
                    <label
                        class="np-detail-collapse__lang np-detail-collapse__lang_checkbox">
                      <input
                          type="radio"
                          name="lanuage"
                          v-model="lang.departureExport"
                          value="RU" />
                      <div class="np-detail-collapse__lang__icon">
                        <svg width="1em" height="1em" class="icon icon-rus">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                        </svg>
                      </div>
                      <span class="np-detail-collapse__lang__text"
                      >Russian</span
                      >
                    </label>
                  </div>
                </div>
                <div class="js-ckeditor">
                  <editor
                      :editor="editor"
                      v-model="
                      data[lang.departureExport]
                        .departureExport
                    "
                      @focus="isEditFlag = true"
                      :config="editorConfig">
                  </editor>
                </div>
              </div>
            </div>
            <div class="added-text__edit">
              <button
                type="button"
                class="btn btn--green"
                @click="updateTextsHandler">
                <span>Save</span>
              </button>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {getTexts, updateTexts} from '@/utilites/api'

import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'

export default {
  components: {editor: CKEditor.component},
  data() {
    return {
      editor: ClassicEditor,
      isEditFlag: false,
      lang: {
        welcome: 'EN',
        welcomeVip: 'EN',
        visa: 'EN',
        visaVip: 'EN',
        back: 'EN',
        summitKilimanjaro: 'EN',
        summitMeru: 'EN',
        ownArrangements: 'EN',
        restDay: 'EN',
        transitNgorongoro: 'EN',
        departure: 'EN',
        departureVip: 'EN',
        covidRegulations: 'EN',
        departureFromNationalPark: 'EN',
        arrival: 'EN',
        arrivalVip: 'EN',
        arrivalImport: 'EN',
        departureExport: 'EN',
      },
      data: {
        RU: {
          welcome: '',
          welcomeVip: '',
          visa: '',
          visaVip: '',
          back: '',
          summitKilimanjaro: '',
          summitMeru: '',
          ownArrangements: '',
          restDay: '',
          transitNgorongoro: '',
          departure: '',
          departureVip: '',
          covidRegulations: '',
          departureFromNationalPark: '',
          arrival: '',
          arrivalVip: '',
          arrivalImport: '',
          departureExport: '',
        },
        EN: {
          welcome: '',
          welcomeVip: '',
          visa: '',
          visaVip: '',
          back: '',
          summitKilimanjaro: '',
          summitMeru: '',
          ownArrangements: '',
          restDay: '',
          transitNgorongoro: '',
          departure: '',
          departureVip: '',
          covidRegulations: '',
          departureFromNationalPark: '',
          arrival: '',
          arrivalVip: '',
          arrivalImport: '',
          departureExport: '',
        },
      },
      editorConfig: {
        placeholder: 'Write text',
      },
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEditFlag) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  methods: {
    updateTextsHandler() {
      updateTexts({texts: this.data})
        .then(() => {
          this.$emit('confirmed')
          this.isEditFlag = false
        })
        .catch(() => {
          this.$emit('errored')
          this.isEditFlag = false
        })
    },
  },
  beforeCreate() {
    document.title = 'Setting & Data | General | Added Texts'
  },
  mounted() {
    const defaultFields = {
      welcome: '',
      welcomeVip: '',
      visa: '',
      visaVip: '',
      back: '',
      summitKilimanjaro: '',
      summitMeru: '',
      ownArrangements: '',
      restDay: '',
      transitNgorongoro: '',
      departure: '',
      departureVip: '',
      covidRegulations: '',
      departureFromNationalPark: '',
    };

    getTexts()
      .then((res) => {
        this.data.RU = res.texts.RU || defaultFields;
        this.data.EN = res.texts.EN || defaultFields;
      })
      .catch(
        () =>
          (this.data = {
            RU: defaultFields,
            EN: defaultFields,
          })
      )
  },
}
</script>
